import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError } from '@angular/material/input';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';
import { API_PARAMS } from '../../../constants/api.constants';
import {
  AppointmentInfoField,
  BusinessCheckupSettingsRequest,
  PersonalCheckupSettingsRequest,
} from '../../../interfaces/appointment-info.model';
import { ModifyExamClothesDialogModel } from '../../../interfaces/dialogs/modify-exam-clothes-dialog.model';
import { AppointmentInfoService } from '../../../services/appointment-info.service';
import { SharedStorageService } from '../../../services/shared-storage.service';
import { ID_LOGIN_TYPE } from '../../../constants/common.constants';
import { ExamItemName } from '../../../interfaces/reserve-confirm-survey.model';
import { AddExamInfo } from '../../../interfaces/reserve-add.model';

/**
 * 修改健檢服dialog組件
 */
@Component({
  selector: 'app-modify-exam-clothes-dialog',
  standalone: true,
  imports: [
    TranslatePipe,
    MatRadioGroup,
    MatRadioButton,
    FormsModule,
    MatButton,
    MatError,
  ],
  templateUrl: './modify-exam-clothes-dialog.component.html',
  styleUrl: './modify-exam-clothes-dialog.component.scss',
})
export class ModifyExamClothesDialogComponent implements OnInit {
  appointmentInfoService: AppointmentInfoService = inject(
    AppointmentInfoService
  );
  sharedStorageService: SharedStorageService = inject(SharedStorageService);

  clothesSizes: Array<AppointmentInfoField> = []; // 健檢服尺寸選項
  selectedClothesSize: string = ''; // 選擇的健檢服尺寸
  
  showError: boolean = false; // 是否顯示錯誤訊息

  constructor(
    public dialogRef: MatDialogRef<ModifyExamClothesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModifyExamClothesDialogModel
  ) {
    // 初始化選擇的健檢服尺寸
    this.selectedClothesSize = data.clothesSize;
  }
 // 是否為個人預約
    get isPersonalReserve(): boolean {
      if(this.sharedStorageService.get('reserveType')){
        //預約流程
        return (
                this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL
              );
      }else{
        //會員中心-我的預約
        if(this.sharedStorageService.get('myReservation')?.companyNo){
          //企業
          return false;
        }else{
          //個人
          return true;
        }
      }
    }
  ngOnInit(): void {

    // 取得加選檢項
    const addList: Array<ExamItemName> =
          this.sharedStorageService
                  .get('addExamItemList')
                  ?.map((addExamInfo: AddExamInfo) => {
                    return {
                      examItem: addExamInfo.examItem,
                      examName: addExamInfo.examName,
                    };
            }) ?? [];

    if (this.isPersonalReserve) {
      console.log("個人預約");
      const userPlanRequest = this.sharedStorageService.get('userPlanRequest');
      const myReservation = this.sharedStorageService.get('myReservation');
      const request: PersonalCheckupSettingsRequest = {
        dataType: API_PARAMS.CHECKUP_SETTINGS_DATATYPE.CLOTHES_SIZE,
        caseNo: myReservation?.caseNo ?? this.sharedStorageService.get('caseNo') ??'',
        companyNo: '1150',
        orgNo: userPlanRequest?.orgNo ?? '',
        gender: userPlanRequest?.gender ?? '',
        idNo: userPlanRequest?.idNo ?? '',
        UUID: userPlanRequest?.uuid ?? '',
        bookDate: myReservation?.bookDate ?? '',
        examItemList: [],
        addList: addList ?? [],
      };
      this.appointmentInfoService.checkupSettings(request).subscribe(res => {
        this.clothesSizes = (res.data?.sizeInfos ?? []).sort(
          (a, b) => Number(a.uno) - Number(b.uno)
        );
      });

    }else{
      console.log("企業預約");
       // 取得加選檢項
      const businessPlanRequest = this.sharedStorageService.get('businessPlanRequest');
      const userPlanRequest = this.sharedStorageService.get('userPlanRequest');//從會員中心過來的
      const idLoginRequest = this.sharedStorageService.get('idLoginRequest');
      const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
      const myReservation = this.sharedStorageService.get('myReservation');
      const request: BusinessCheckupSettingsRequest = {
            dataType: API_PARAMS.CHECKUP_SETTINGS_DATATYPE.CLOTHES_SIZE,
            caseNo: myReservation?.caseNo ?? this.sharedStorageService.get('caseNo') ??'',
            companyNo: '',//選填
            familyFlag:'',//選填
            orgNo: businessPlanRequest?.orgNo ?? userPlanRequest?.orgNo ?? '',
            gender: businessPlanRequest?.gender ?? userPlanRequest?.gender ?? '',
            idNo: idLoginRequest?.idNo ?? createMemberRequest?.idNo ?? '',
            bookDate: myReservation?.bookDate ?? '',
            examItemList: [],//選填
            addList:  [],//選填
          };
      console.log('企業檢查request:', request);
      // CB-074
      this.appointmentInfoService
            .businessCheckupSettings(request)
            .subscribe(res => {
              this.clothesSizes = (res.data?.sizeInfos ?? []).sort(
                (a, b) => Number(a.uno) - Number(b.uno)
              );
            });
    }
    
  }

  
  // 關閉dialog
  closeDialog() {
    this.dialogRef.close(null);
  }

  // 儲存修改
  onSubmit() {
    this.showError = true;
    if (this.selectedClothesSize) {
      const clothesSizeNoDesc =
        this.clothesSizes.find(item => item.uno === this.selectedClothesSize)?.noDesc ??
          '';
      this.dialogRef.close({
        clothesSize: this.selectedClothesSize,
        clothesSizeNoDesc: clothesSizeNoDesc,
      } as ModifyExamClothesDialogModel);
    }
  }

  protected readonly API_PARAMS = API_PARAMS;
}
